import React from 'react';
import { motion } from 'framer-motion';
import { Award, Banknote, UserCheck } from 'lucide-react';
const CARDS = [{
  icon: Award,
  title: 'For carriers with authority',
  desc: 'Support for carriers running under their own MC who need help staying organized and loaded.'
}, {
  icon: Banknote,
  title: 'Dispatch-to-cash support',
  desc: 'Help around the work from load planning and rate cons through paperwork and billing.'
}, {
  icon: UserCheck,
  title: 'Built around your profile',
  desc: 'Loads and broker setup should match your equipment, authority, documents, and operating goals.'
}];
export function NotJustBooking() {
  return <section className="section-padding bg-white border-t border-steel" data-id="element-283">
      <div className="container-custom" data-id="element-284">
        <div className="max-w-3xl mb-10" data-id="element-285">
          <h2 className="text-3xl md:text-4xl font-black text-navy mb-4 tracking-tight" data-id="element-286">
            Not Just Load Booking. The Operating Layer Around Every Load.
          </h2>
          <p className="text-lg text-body font-medium leading-relaxed" data-id="element-287">
            Cheap dispatch can still leave the burden on your plate. FSG is
            built around a fuller carrier workflow: load planning, paperwork,
            rate cons, broker setup, billing support, and moving the process
            from one load to the next.
          </p>
        </div>
        <div className="grid sm:grid-cols-3 gap-6" data-id="element-288">
          {CARDS.map((card, i) => <motion.div key={i} initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-off-white border border-steel rounded-sm p-8 flex flex-col items-start h-full" data-id="element-289">
              <card.icon className="w-7 h-7 text-red mb-4" data-id="element-290" />
              <h3 className="font-bold text-navy text-lg mb-2" data-id="element-291">{card.title}</h3>
              <p className="text-body font-medium leading-relaxed" data-id="element-292">
                {card.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}